import { render, staticRenderFns } from "./UserSupervisedAgencyProjectsList.vue?vue&type=template&id=16daff83&scoped=true&"
import script from "./UserSupervisedAgencyProjectsList.vue?vue&type=script&lang=js&"
export * from "./UserSupervisedAgencyProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16daff83",
  null
  
)

export default component.exports